import axios from "axios";
import $axios from "../api/accessor";
import { $api } from "../api/api";

export const SellersService = {
  async getAllSellers(category_id: string | null, country_id: string | null) {
    const params: Record<string, string> = {};

    if (category_id !== null) {
      params.category = category_id;
    }

    if (country_id !== null) {
      params.location = country_id;
    }

    let response = await $axios.get($api("sellers", params)).catch((err) => {
      return err.response;
    });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getSellersByUrl(url: string) {
    let response = await axios.get(url);
    return response;
  },

  async getAllStoreCategory() {
    let response = await $axios.get($api("store_category"), {}).catch((err) => {
      return err.response;
    });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
